(function () {
  var root = document.getElementById('mf-popup');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';

  var SENT = 'mfPopupSent', VISIT = 'mfPopupVisit', CHOICE = 'mfPopupChoice';
  function get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function set(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function getV() { try { return sessionStorage.getItem(VISIT); } catch (e) { return null; } }
  function setV() { try { sessionStorage.setItem(VISIT, '1'); } catch (e) {} }

  var isDesign = root.dataset.design === 'true';
  var lastFocus = null;
  var form = root.querySelector('form');
  var tagsInput = root.querySelector('[data-mf-tags]');
  var emailInput = root.querySelector('#MfPopupEmail');
  var emailError = root.querySelector('[data-mf-email-error]');
  var phoneInput = root.querySelector('[data-mf-phone]');
  var phoneError = root.querySelector('[data-mf-phone-error]');
  var prefixSel = root.querySelector('[data-mf-prefix]');
  var submitBtn = form ? form.querySelector('button[type="submit"]') : null;

  function showStep(name) {
    root.querySelectorAll('[data-mf-step]').forEach(function (el) {
      el.hidden = el.getAttribute('data-mf-step') !== name;
    });
    /* La foto solo sale en la primera pantalla */
    root.classList.toggle('is-later', name !== 'form');
    var box = root.querySelector('.mf-popup__box');
    if (box) box.scrollTop = 0;
  }
  function showThanksFor(choice) {
    var isOrac = (choice || '').indexOf('calculo-material') > -1;
    root.querySelectorAll('[data-mf-for]').forEach(function (el) {
      el.hidden = el.getAttribute('data-mf-for') !== (isOrac ? 'orac' : 'reforma');
    });
  }
  function open(step) {
    showStep(step || 'form');
    lastFocus = document.activeElement;
    root.hidden = false;
    requestAnimationFrame(function () { root.classList.add('is-open'); });
    document.documentElement.style.overflow = 'hidden';
    if (!isDesign) setV();
  }
  function close() {
    root.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    setTimeout(function () { root.hidden = true; }, 250);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  function chosen() {
    var r = root.querySelector('input[name="mf_choice"]:checked');
    return r ? r.value : 'visita-gratis';
  }
  function emailOk(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v); }

  root.querySelectorAll('[data-mf-close]').forEach(function (el) {
    el.addEventListener('click', close);
  });

  /* Pantalla 1 -> 2 */
  var nextBtn = root.querySelector('[data-mf-next]');
  if (nextBtn) nextBtn.addEventListener('click', function () {
    var v = (emailInput.value || '').trim();
    if (!emailOk(v)) {
      emailError.textContent = 'Revisa el correo: no parece válido.';
      emailInput.focus();
      return;
    }
    emailError.textContent = '';
    emailInput.value = v;
    showStep('phone');
    if (phoneInput) setTimeout(function () { phoneInput.focus(); }, 50);
  });
  if (emailInput) emailInput.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') { e.preventDefault(); nextBtn.click(); }
  });

  /* Envío: con teléfono o sin él */
  function send(withPhone) {
    var tags = ['popup', chosen()];
    if (withPhone) {
      var digits = (phoneInput.value || '').replace(/\D/g, '');
      var pre = prefixSel ? prefixSel.value : '34';
      if (digits.indexOf(pre) === 0 && digits.length > 9) digits = digits.slice(pre.length);
      if (digits.length < 6 || digits.length > 12) {
        phoneError.textContent = 'Revisa el número de teléfono.';
        phoneInput.focus();
        return false;
      }
      phoneError.textContent = '';
      tags.push('tel-' + pre + digits);
    }
    tagsInput.value = tags.join(',');
    set(SENT, 'pending');
    set(CHOICE, chosen());
    return true;
  }
  if (form) form.addEventListener('submit', function (e) {
    var hasPhone = phoneInput && (phoneInput.value || '').trim() !== '';
    if (!send(hasPhone)) e.preventDefault();
  });
  /* "No, gracias": se envía igual que el botón normal (así pasa la verificación anti-spam de Shopify) */
  var skipBtn = root.querySelector('[data-mf-skip]');
  if (skipBtn) skipBtn.addEventListener('click', function () {
    if (phoneInput) phoneInput.value = '';
    if (phoneError) phoneError.textContent = '';
    if (form.requestSubmit) {
      form.requestSubmit(submitBtn || undefined);
    } else if (submitBtn) {
      submitBtn.click();
    }
  });

  var copyBtn = root.querySelector('[data-mf-copy]');
  var codeEl = root.querySelector('[data-mf-code]');
  if (copyBtn && codeEl) {
    copyBtn.addEventListener('click', function () {
      var code = codeEl.textContent.trim();
      function done() { copyBtn.textContent = '¡Copiado!'; setTimeout(function () { copyBtn.textContent = 'Copiar'; }, 2000); }
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done, done);
          return;
        }
      } catch (e) {}
      done();
    });
  }

  if (isDesign) {
    var id = root.dataset.sectionId;
    document.addEventListener('shopify:section:select', function (e) {
      if (e.detail && e.detail.sectionId === id) open('form');
    });
    document.addEventListener('shopify:section:deselect', function (e) {
      if (e.detail && e.detail.sectionId === id) close();
    });
    return;
  }

  var params = new URLSearchParams(window.location.search);
  var pending = get(SENT) === 'pending';
  if (pending && params.get('customer_posted') === 'true') {
    set(SENT, 'done');
    showThanksFor(get(CHOICE));
    open('thanks');
    return;
  }
  var errors = root.querySelector('[data-mf-email-error]');
  if (pending && errors && errors.textContent.trim()) {
    set(SENT, '');
    open('form');
    return;
  }
  /* Quien ya dejó su correo no lo vuelve a ver */
  if (get(SENT) === 'done') return;
  /* Una vez por visita */
  if (getV() === '1') return;

  var delay = parseInt(root.dataset.delay, 10);
  if (isNaN(delay)) delay = 5;
  /* En la portada: esperar a que termine el vídeo de entrada y abrir 4 s después */
  if (document.querySelector('.dp-intro')) {
    var tries = 0;
    var waitIntro = setInterval(function () {
      tries++;
      if (!document.querySelector('.dp-intro:not(.is-out)') || tries > 150) {
        clearInterval(waitIntro);
        setTimeout(function () { open('form'); }, 4000);
      }
    }, 200);
  } else {
    setTimeout(function () { open('form'); }, delay * 1000);
  }
})();